import { extendTheme } from '@chakra-ui/react';

const colors = {
    color: {
        50: '#fffaf9',
        100: '#ffe2e0',
        200: '#ffbaba',
        300: '#f98c85',
        400: '#e85a54',
        500: '#b33938', // Vermelho terroso principal
        600: '#8a2a2b',
        700: '#5c1c1e',
        800: '#fdfdfd', // Branco quente
        900: '#ffffff', // Branco puro
    },
    gray: {
        50: '#f7fafc',
        100: '#e1e5ea',
        200: '#c7ccd4',
        300: '#aab1bb',
        400: '#8b929d',
        500: '#6f7785',
        600: '#585f6b',
        700: '#41454e',
        800: '#2b2d35',
        900: '#16171a',
    },
};

const styles = {
    global: {
        body: {
            bg: 'brand.900', // branco
            color: 'gray.900', // texto escuro
        },
    },
};

const theme = extendTheme({ colors, styles });

export default theme;
